import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  CardMedia,
  Grid,
} from "@mui/material";
import { Helmet } from "react-helmet";
import BannerOne from "../../assets/images/banner-one.jpg";
import DiffServices1 from "../../assets/images/diff_service1.png";
import DiffServices2 from "../../assets/images/diff_service2.png";
import notre_ambition from "../../assets/images/FrankIcons/notre-ambition.png";
import CustomButton from "../../UiComponent/CustomButton";
import CustomFooter from "../../UiComponent/CustomFooter";
import NewHeader from "../../UiComponent/NewHeader";
import { defaultLabelColors, spacing } from "../../utils/constants";
import "./index.css";

import { useMediaQuery, useTheme } from "@mui/system";
import React from "react";
import {
  ForwardCircleIcon,
  NosValueImage1,
  NosValueImage2,
  NosValueImage3,
} from "../../assets/images/FrankIcons";
import { useResponsiveValue1024 } from "../../utils/helper";
import CustomMobileFooter from "../../UiComponent/CustomMobileFooter";
import MobileResponsive from "../LandingPage/MobileResponsive";
import { Squircle } from "corner-smoothing";

import BannerTablet from "../../assets/images/FrankIcons/about-banner-tablet.png";

function AboutPage(props: any) {
  const theme = useTheme();
  const lg = useMediaQuery(theme.breakpoints.up("lg"));
  const xl = useMediaQuery(theme.breakpoints.up("xl"));
  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const screen_600 = useMediaQuery(theme.breakpoints.up(601));

  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      activity: false,
      page: 1,
      expanded_1: false,
      expanded_2: false,
      expanded_3: false,
      expanded_4: false,
      expanded_5: false,
      expanded_6: false,
      expanded_7: false,
    }
  );

  const handleExpanded = (state_name: any) => {
    try {
      setState({ [state_name]: !state?.[state_name] });
    } catch (error) {}
  };
  const diff_services = [
    {
      image: DiffServices1, // Use a meaningful image URL
      title: "Livraison collaborative",
      sub_title:
        "Envoyez vos colis entre particuliers en publiant votre annonce et indiquez les détails concernant le colis et sa destination.",
    },
    {
      image: DiffServices2, // Use a meaningful image URL
      title: "Transport sécurisé",
      sub_title:
        "Confiez votre colis à un particulier de confiance qui effectue déjà le trajet souhaité pour une livraison rapide et économique.",
    },
  ];
  const pour_qui = [
    {
      title: "Expéditeurs",
      sub_title:
        "Vous envoyez vos colis partout en France et profitez de tarifs compétitifs.",
    },
    {
      title: "Transporteurs",
      sub_title:
        "Vous rentabilisez l'espace inoccupé de votre véhicule et votre trajet en prenant en charge des colis.",
    },
    {
      title: "E-commerçants",
      sub_title:
        "Vous expédiez votre marchandise de façon éco-responsable et économique.",
    },
  ];
  // const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Qui sommes-nous ? | Frank</title>
        <link rel="canonical" href="www.frank.fr" />

        <link
          rel="icon"
          type="image/ico"
          href="../../assets/images/FrankIcons/favicon.ico"
        />
        <meta
          name="description"
          content="Quel est le concept porté par Frank ? Découvrez-en plus sur notre équipe, nos ambitions, notre communauté et nos valeurs."
        />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Frank",
            contactPoint: {
              "@type": "ContactPoint",
              contactType: "Customer Service",
              areaServed: "FR",
              availableLanguage: "French",
            },
          })}
        </script>
      </Helmet>
      <div
        className="web-screen"
        style={{
          background: defaultLabelColors?.main_background_new,
        }}
      >
        <div
          style={{
            background: defaultLabelColors.main_background_new,
            justifyItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              maxWidth: 1408,
              width: "100%",
            }}
          >
            <NewHeader />
            <div
              style={{
                marginTop: 60,
                display: "flex",
                flexDirection: "column",
                gap: screen_1024 ? 40 : 20,
                paddingTop: screen_1024 ? 50 : 20,
              }}
            >
              <div className="display-flex" style={{ flexDirection: "column" }}>
                <h1
                  style={{
                    marginBottom: 0,
                    fontFamily: "montserrat-Bold",
                    // fontSize: 50,
                    fontSize: useResponsiveValue1024("50px", "22px"),
                  }}
                >
                  Qui sommes nous ?
                </h1>
                <p
                  style={{
                    // marginTop:0,
                    fontFamily: screen_1024
                      ? "montserrat-Medium"
                      : "montserrat-Regular",
                    // fontSize: 22,
                    fontSize: useResponsiveValue1024("22px", "12px"),

                    textAlign: "center",
                  }}
                >
                  {screen_1024 ? (
                    <>
                      Frank, c'est un service de livraison alternatif à
                      destination des
                      <br />
                      particuliers comme des professionnels.
                    </>
                  ) : (
                    <>
                      Frank, c'est un service de livraison alternatif <br /> à
                      destination des particuliers comme <br /> des
                      professionnels.
                    </>
                  )}
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  paddingLeft: screen_1024 ? 40 : 16,

                  paddingRight: screen_1024 ? 40 : 16,
                }}
              >
                <div
                  className="about-banner-one"
                  style={{ position: "relative" }}
                >
                  <img
                    src={screen_1024 ? BannerOne : BannerTablet}
                    alt="banner-img"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                    }}
                    height={"100%"}
                    width={"100%"}
                  />
                  <div className="banner-text-align">
                    <h2
                      style={{
                        fontFamily: "montserrat-Bold",
                        fontSize: screen_1024 ? "26px" : "20px",
                        color: "#fff",
                      }}
                      className="about_image_text"
                    >
                      L'idée est née d'un constat simple
                    </h2>
                    <p
                      style={{
                        width: "60%",
                        fontFamily: "montserrat-Medium",
                        // fontSize: 18,
                        // fontSize: useResponsiveValue1024("18px", "14px"),

                        color: "#fff",
                      }}
                      className="about_image_para"
                    >
                      chaque jour, un grand nombre de personnes traversent la
                      France dans des véhicules presque vides.<br></br> D'un
                      point de vue écologique et logistique, c'est loin d'être
                      optimal !
                    </p>
                    <p
                      style={{
                        width: "60%",

                        fontFamily: "montserrat-Medium",
                        // fontSize: 22,
                        // fontSize: useResponsiveValue1024("22px", "14px"),

                        color: "#fff",
                      }}
                      className="about_image_para"
                    >
                      Pourquoi ne pas mettre en relation les personnes pour
                      rentabiliser cet espace et proposer une livraison de colis
                      économique et écologique ? <br></br>C’est la que Frank
                      arrive !
                    </p>
                  </div>
                </div>
              </div>
              <Grid
                container
                spacing={spacing?.spacing2}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div>
                  <p
                    style={{
                      fontFamily: "montserrat-Bold",
                      // fontSize: "52px",
                      fontSize: useResponsiveValue1024("50px", "22px"),

                      color: "#000000",
                      textAlign: "center",
                      fontWeight: "800",
                      margin: screen_1024 ? 0 : "20px 0px",
                    }}
                  >
                    Notre ambition{" "}
                  </p>

                  <p
                    style={{
                      fontFamily: "montserrat-Medium",
                      // fontSize: "22px",
                      fontSize: useResponsiveValue1024("22px", "14px"),

                      color: "#000",
                      // marginTop: "20px",
                    }}
                  >
                    <span> Notre objectif:</span> mettre en relation les
                    personnes qui ont besoin d'envoyer un
                    <br /> colis avec celles qui ont de la place dans leur
                    véhicule. Le résultat ?
                  </p>
                </div>
              </Grid>
              <Grid container spacing={spacing?.spacing2}>
                <div style={{ objectFit: "contain" }}>
                  <img
                    src={notre_ambition}
                    style={{ height: "100%", width: "100%" }}
                    alt=""
                  />
                </div>
              </Grid>
              <Grid
                container
                spacing={spacing?.spacing2}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div>
                  <p
                    style={{
                      fontFamily: "montserrat-Medium",
                      // fontSize: "22px",
                      fontSize: useResponsiveValue1024("22px", "12px"),

                      color: "#000",
                      textAlign: "center",
                      marginTop: 0,
                    }}
                  >
                    Ensemble, créons une communauté pour révolutionner le
                    transport de colis
                  </p>
                </div>
                <div>
                  <CustomButton
                    value={"Cette communauté : c’est vous !"}
                    // value={"Cette communauté : C’est vous"}
                    // classesNames={"custom-button"}
                    style={{
                      // fontSize: "16px",
                      fontSize: useResponsiveValue1024("16px", "14px"),

                      fontWeight: "500",
                      color: "#fff",
                      fontFamily: "montserrat-Bold",
                      background: "#ee6931",
                      border: "none",
                      borderRadius: "12px",
                      padding: "10px 40px 10px 40px",
                      marginLeft: "10px",
                    }}
                    onClick={() =>
                      window.open(
                        "https://www.instagram.com/frankme.fr/",
                        "_blank",
                        "noopener,noreferrer"
                      )
                    }
                  />
                </div>
              </Grid>
              <div
                className="display-flex"
                style={{
                  flexDirection: "column",
                  paddingLeft: xl || lg ? 160 : 80,

                  paddingRight: xl || lg ? 160 : 80,
                }}
              >
                <h3
                  style={{
                    // marginBottom: 0,
                    margin: screen_1024 ? "20px 0px" : "0px ",
                    fontFamily: "montserrat-Bold",
                    // fontSize: 50,
                    fontSize: useResponsiveValue1024("50px", "22px"),
                  }}
                >
                  Frank, comment ça marche ?{" "}
                </h3>
                <p
                  style={{
                    // marginTop:0,
                    fontFamily: screen_1024
                      ? "montserrat-Medium"
                      : "montserrat-Regular",
                    // fontSize: 22,
                    fontSize: useResponsiveValue1024("22px", "14px"),

                    textAlign: "center",
                  }}
                >
                  De nos jours, envoyer un colis, c'est toute une aventure ! Et
                  plus il est volumineux, plus cela revient cher.
                </p>

                <p
                  style={{
                    // marginTop:0,
                    fontFamily: screen_1024
                      ? "montserrat-Medium"
                      : "montserrat-Regular",
                    // fontSize: 22,
                    fontSize: useResponsiveValue1024("22px", "14px"),

                    textAlign: "center",
                  }}
                >
                  C'est pour cette raison que Frank existe : simplifier les
                  envois des particuliers et des professionnels qui veulent s'y
                  retrouver financièrement.
                </p>
                <p
                  style={{
                    // marginTop:0,
                    fontFamily: screen_1024
                      ? "montserrat-Medium"
                      : "montserrat-Regular",
                    // fontSize: 22,
                    fontSize: useResponsiveValue1024("22px", "14px"),

                    textAlign: "center",
                  }}
                >
                  Pour cela, nous avons misé sur une interface simple et
                  transparente. Sur notre site ou sur l'appli, vous planifiez
                  votre envoi, vous définissez le tarif que vous souhaitez et
                  hop, votre annonce est en ligne. Ensuite, la livraison est
                  assurée par un transporteur de la communauté. Facile, non ?{" "}
                </p>
              </div>
              <div
                className="display-flex"
                style={{
                  flexDirection: "column",
                  padding: "0px 16px",
                }}
              >
                <h3
                  style={{
                    marginTop: 0,
                    fontFamily: "montserrat-Bold",
                    // fontSize: 50,

                    fontSize: useResponsiveValue1024("50px", "22px"),
                  }}
                >
                  Nos différents services{" "}
                </h3>
                <div style={{ display: "flex", flexDirection: "row", gap: 20 }}>
                  {diff_services?.map((item: any) => {
                    return (
                      <>
                        <div
                          style={{
                            width: screen_1024 ? "404px" : "50%",
                            background: "#fff",
                            borderRadius: 8,
                            padding: screen_1024 ? "10px 20px" : "10px 10px",
                          }}
                          // className="cards__item"
                        >
                          <div className="card">
                            <Squircle
                              cornerRadius={16}
                              cornerSmoothing={0.6}
                              preserveSmoothing
                            >
                              <CardMedia
                                component="img"
                                style={{
                                  height: 186,
                                  objectFit: screen_1024 ? "contain" : "cover",
                                  // padding:"0px 10px",
                                  width: "100%",
                                }}
                                image={item?.image} // Replace with the image URL you need
                                alt="Blog card image"
                              />
                            </Squircle>

                            <div className="card__content">
                              <div style={{ display: "flex" }}>
                                <div
                                  className="card__title"
                                  style={{
                                    flex: 1,
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    WebkitLineClamp: 2, // Limits text to 2 lines
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal", // Allows wrapping
                                    color: "#16192C",
                                    fontFamily: "montserrat-SemiBold",
                                    // fontSize: useResponsiveValue1024("24px","18px"),
                                  }}
                                >
                                  {item?.title}
                                </div>
                              </div>
                              <p
                                className="card__text_new"
                                style={{
                                  // margin: 0,
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 4, // Limits text to 2 lines
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal", // Allows wrapping
                                  // color:"#16192C",
                                  fontFamily: "montserrat-Regular",
                                }}
                              >
                                {item?.sub_title}
                              </p>
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
              <div
                className="display-flex"
                style={{
                  flexDirection: "column",
                  padding: "0px 16px",
                }}
              >
                <h3
                  style={{
                    marginTop: 0,
                    fontFamily: "montserrat-Bold",
                    fontSize: useResponsiveValue1024("50px", "22px"),
                    //
                  }}
                >
                  Pour qui ?
                </h3>
                <div
                  style={{
                    display: "flex",
                    flexDirection: screen_1024 ? "row" : "column",
                    gap: 20,
                  }}
                >
                  {pour_qui?.map((item: any) => {
                    return (
                      <>
                        <div
                          style={{
                            width: screen_1024 ? "33%" : "unset",
                            background: "#fff",
                            borderRadius: 32,
                            padding: "10px 20px",
                          }}
                          // className="cards__item"
                        >
                          <div
                            className="card"
                            style={{ flexDirection: "row" }}
                          >
                            <div className="card__content">
                              <div style={{ display: "flex" }}>
                                <div
                                  className="card__title"
                                  style={{
                                    flex: 1,
                                    display: "-webkit-box",
                                    WebkitBoxOrient: "vertical",
                                    // WebkitLineClamp: 2, // Limits text to 2 lines
                                    overflow: "hidden",
                                    textOverflow: "ellipsis",
                                    whiteSpace: "normal", // Allows wrapping
                                    color: "#080626",
                                    fontFamily: "montserrat-Bold",
                                    fontSize: screen_1024 ? 28 : 18,
                                  }}
                                >
                                  {item?.title}
                                </div>
                              </div>
                              <p
                                className="card__text_new"
                                style={{
                                  // margin: 0,
                                  display: "-webkit-box",
                                  WebkitBoxOrient: "vertical",
                                  WebkitLineClamp: 4, // Limits text to 2 lines
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "normal", // Allows wrapping
                                  color: "#626175",
                                  // fontSize: 14,
                                  fontSize: screen_1024 ? 14 : 12,

                                  fontFamily: "montserrat-Regular",
                                }}
                              >
                                {item?.sub_title}
                              </p>
                            </div>
                            <div className="display-flex">
                              <ForwardCircleIcon
                                width={screen_1024 ? "100" : "37"}
                                height={screen_1024 ? "101" : "37"}
                              />
                            </div>
                          </div>
                        </div>
                      </>
                    );
                  })}
                </div>
              </div>
              {/* /// */}
              <div
                className="display-flex"
                style={{
                  flexDirection: "column",
                  // paddingLeft: xl || lg ? 160 : 80,
                  // paddingRight: xl || lg ? 160 : 80,
                }}
              >
                {/* Title */}
                <h3
                  style={{
                    marginTop: 0,
                    fontFamily: "montserrat-Bold",
                    // fontSize: 50,
                    fontSize: useResponsiveValue1024("50px", "22px"),
                  }}
                >
                  Nos valeurs
                </h3>
                {/* Flex container for cards */}
                <div
                  style={{
                    display: "flex",
                    flexDirection: screen_1024 ? "row" : "column",
                    gap: 20,
                  }}
                >
                  {/* Card 1 */}
                  <div
                    style={{
                      width: screen_1024 ? "33%" : "unset",
                      background: "#FFF8F5",
                      borderRadius: 8,
                      padding: "10px 20px",
                    }}
                    id="card11"
                  >
                    <div className="card" style={{ gap: 30 }}>
                      <div
                        className="display-flex"
                        style={{
                          objectFit: "contain",
                          borderRadius: 8,
                          width: "100%",
                        }}
                      >
                        <NosValueImage1
                          width={screen_1024 ? "100" : "64"}
                          height={screen_1024 ? "101" : "64"}
                        />
                      </div>
                      <div className="card__content_about" style={{ gap: 30 }}>
                        <div style={{ display: "flex" }}>
                          <div
                            className="card__title"
                            style={{
                              flex: 1,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#000000",
                              fontFamily: "montserrat-Bold",
                              fontSize: screen_1024 ? 28 : 18,
                            }}
                          >
                            Connecter les personnes
                          </div>
                        </div>
                        <div id="para-div">
                          <p
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#626175",
                              fontFamily: "montserrat-Regular",
                              fontSize: 14,
                              textAlign: screen_1024 ? "left" : "center",
                            }}
                          >
                            Pour nous, “mettre en relation” des personnes,
                            {!screen_1024 && <br></br>} ce n’est pas uniquement
                            créer une plateforme collaborative où chacun trouve
                            son compte.
                          </p>
                          <p
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#626175",
                              fontFamily: "montserrat-Regular",
                              fontSize: 14,
                              textAlign: screen_1024 ? "left" : "center",
                            }}
                          >
                            C’est aussi rapprocher les gens et créer une
                            communauté qui partage nos valeurs{" "}
                            {!screen_1024 && <br></br>} d’entraide, d’efficacité
                            et de convivialité: les Frankies.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div
                    style={{
                      width: screen_1024 ? "33%" : "unset",
                      background: "#FFF8F5",
                      borderRadius: 8,
                      padding: "10px 20px",
                    }}
                    id="card22"
                  >
                    <div className="card" style={{ gap: 30 }}>
                      <div
                        className="display-flex"
                        style={{
                          objectFit: "contain",
                          borderRadius: 8,
                          width: "100%",
                        }}
                      >
                        <NosValueImage2
                          width={screen_1024 ? "100" : "64"}
                          height={screen_1024 ? "101" : "64"}
                        />
                      </div>
                      <div className="card__content_about" style={{ gap: 30 }}>
                        <div style={{ display: "flex" }}>
                          <div
                            className="card__title"
                            style={{
                              flex: 1,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 2,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#000000",
                              fontFamily: "montserrat-Bold",
                              // fontSize: 28,
                              fontSize: screen_1024 ? 28 : 18,
                            }}
                          >
                            Efficacité et simplicité
                          </div>
                        </div>
                        <div>
                          <p
                            className="card__text_new"
                            style={{
                              margin: 0,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#626175",
                              fontFamily: "montserrat-Regular",
                              textAlign: screen_1024 ? "left" : "center",
                            }}
                          >
                            Nous avons pensé notre système de la façon la plus
                            simple possible.
                          </p>
                          <ul
                            style={{
                              color: "#626175",
                              paddingInlineStart: 20,
                              fontFamily: "montserrat-Regular",
                              fontSize: 16,
                              textAlign: screen_1024 ? "left" : "center",
                              listStyle: "none",
                            }}
                          >
                            <li className="custom-marker">
                              • Mise en relation
                            </li>
                            <li className="custom-marker">
                              • Prise en charge du colis
                            </li>
                            <li className="custom-marker">
                              • Réception de la commande
                            </li>
                          </ul>
                          <p
                            className="card__text_new"
                            style={{
                              margin: 0,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#626175",
                              fontFamily: "montserrat-Regular",
                            }}
                          >
                            Vous faites des économies, mais vous y gagnez aussi
                            en sécurité.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Card 3 */}
                  <div
                    style={{
                      width: screen_1024 ? "33%" : "unset",
                      background: "#FFF8F5",
                      borderRadius: 8,
                      padding: "10px 20px",
                    }}
                    id="card33"
                  >
                    <div className="card" style={{ gap: 30 }}>
                      <div
                        className="display-flex"
                        style={{
                          objectFit: "contain",
                          borderRadius: 8,
                          width: "100%",
                        }}
                      >
                        <NosValueImage3
                          width={screen_1024 ? "100" : "64"}
                          height={screen_1024 ? "101" : "64"}
                        />
                      </div>
                      <div className="card__content_about" style={{ gap: 30 }}>
                        <div style={{ display: "flex" }}>
                          <div
                            className="card__title"
                            style={{
                              flex: 1,
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#000000",
                              fontFamily: "montserrat-Bold",
                              // fontSize: 28,
                              fontSize: screen_1024 ? 28 : 18,
                              width: "300px",
                              textAlign: screen_1024 ? "left" : "center",
                            }}
                          >
                            Un impact positif sur l’environnement et sur votre
                            portefeuille
                          </div>
                        </div>
                        <div>
                          <p
                            className="card__text_new"
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#626175",
                              fontFamily: "montserrat-Regular",
                              textAlign: screen_1024 ? "left" : "center",
                            }}
                          >
                            Saviez-vous que 41% des véhicules circulent avec un
                            seul passager ?
                          </p>
                          <p
                            className="card__text_new"
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#626175",
                              fontFamily: "montserrat-Regular",
                              textAlign: screen_1024 ? "left" : "center",
                            }}
                          >
                            Ce phénomène concerne également les camions, qui
                            effectuent de nombreux trajets avec un coffre
                            partiellement chargé, voire complètement vide.
                          </p>
                          <p
                            className="card__text_new"
                            style={{
                              display: "-webkit-box",
                              WebkitBoxOrient: "vertical",
                              WebkitLineClamp: 4,
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "normal",
                              color: "#626175",
                              fontFamily: "montserrat-Regular",
                              textAlign: screen_1024 ? "left" : "center",
                            }}
                          >
                            En optimisant l'utilisation de ces camions pour le
                            transport de colis, Frank contribue à réduire
                            l'empreinte carbone du secteur.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* //// */}
              <div
                className="display-flex"
                style={{
                  // paddingLeft: xl || lg ? 160 : 80,

                  // paddingRight: xl || lg ? 160 : 80,
                  padding: "0px 16px",
                  flexDirection: "column",
                }}
              >
                <Grid
                  container
                  spacing={2}
                  style={{
                    padding: 10,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <Grid xs={12} item>
                    <h3
                      style={{
                        color: "#281208",
                        fontFamily: "montserrat-Bold",
                        fontSize: 28,
                      }}
                    >
                      FAQ
                    </h3>
                  </Grid>

                  <Grid
                    xs={12}
                    item
                    className="display-flex"
                    style={{
                      flexDirection: "column",
                      padding: "10px",
                      borderRadius: "18px",
                      gap: 20,
                    }}
                  >
                    <Accordion
                      elevation={0}
                      style={{
                        border: "0px",
                        background: defaultLabelColors?.main_background_new,
                      }}
                      expanded={state?.expanded_1}
                      onChange={() => handleExpanded("expanded_1")}
                    >
                      <AccordionSummary
                        style={{ border: "none", marginTop: 20 }}
                        // expandIcon={<AddIcon />}
                        expandIcon={
                          state?.expanded_1 ? (
                            <RemoveIcon
                              style={{
                                color: defaultLabelColors.main_orange_new,
                              }}
                            />
                          ) : (
                            <AddIcon />
                          )
                        } // Dynamic icon change
                        className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "500",
                            fontFamily: "montserrat-Medium",
                            fontSize: screen_1024 ? 22 : 18,
                          }}
                        >
                          Comment fonctionne la livraison collaborative ?{" "}
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          width: "90%",
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          fontSize: screen_1024 ? 18 : 14,
                        }}
                      >
                        Grâce à notre plateforme, un particulier peut envoyer un
                        colis qui sera livré par un autre particulier lors d’un
                        de ses trajets personnels. Au cœur de notre activité, la
                        livraison collaborative nous permet de créer une
                        communauté d’entraide en garantissant un service d’envoi
                        peu coûteux et écologique.
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      elevation={0}
                      style={{
                        border: "0px",
                        background: defaultLabelColors?.main_background_new,
                      }}
                      expanded={state?.expanded_2}
                      onChange={() => handleExpanded("expanded_2")}
                    >
                      <AccordionSummary
                        style={{ border: "none", marginTop: 20 }}
                        // expandIcon={<AddIcon />}
                        expandIcon={
                          state?.expanded_2 ? (
                            <RemoveIcon
                              style={{
                                color: defaultLabelColors.main_orange_new,
                              }}
                            />
                          ) : (
                            <AddIcon />
                          )
                        } // Dynamic icon change
                        className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "500",
                            fontFamily: "montserrat-Medium",
                            // fontSize: 22,
                            fontSize: screen_1024 ? 22 : 18,

                            padding: "20px 0px",
                          }}
                        >
                          Comment fonctionne la livraison professionnelle avec
                          Frank ?{" "}
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          width: "90%",
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          // fontSize: 18,
                          fontSize: screen_1024 ? 18 : 14,
                        }}
                      >
                        <p>
                          {" "}
                          Nous couvrons l’envoi du premier au dernier kilomètre
                          et stockons vos colis dans notre entrepôt en
                          Île-de-France. En fonction de vos besoins, nous
                          proposons plusieurs modes de livraison professionnelle
                          :
                        </p>

                        <p>
                          {" "}
                          • Pick & Pack : récupération des colis à votre
                          adresse, préparation des colis, packaging d’envoi{" "}
                        </p>
                        <p>
                          {" "}
                          • Livraison totale : nous nous occupons de tout, de la
                          récupération des colis jusqu’à leur dépôt chez le
                          client final{" "}
                        </p>
                        <p>
                          {" "}
                          • Stockage : nous stockons vos colis dans notre
                          entrepôt en Île-de-France, avant leur retrait
                        </p>

                        <p>
                          Pour plus d’informations, vous pouvez nous contacter
                          en envoyant un mail à l’adresse :
                          <a href="mailto:hello@frankme.com">
                            hello@frankme.com
                          </a>
                          .
                        </p>
                      </AccordionDetails>
                    </Accordion>
                    <Accordion
                      elevation={0}
                      style={{
                        border: "0px",
                        background: defaultLabelColors?.main_background_new,
                      }}
                      expanded={state?.expanded_3}
                      onChange={() => handleExpanded("expanded_3")}
                    >
                      <AccordionSummary
                        style={{ border: "none", marginTop: 20 }}
                        // expandIcon={<AddIcon />}
                        expandIcon={
                          state?.expanded_3 ? (
                            <RemoveIcon
                              style={{
                                color: defaultLabelColors.main_orange_new,
                              }}
                            />
                          ) : (
                            <AddIcon />
                          )
                        } // Dynamic icon change
                        className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "500",
                            fontFamily: "montserrat-Medium",
                            // fontSize: 22,
                            fontSize: screen_1024 ? 22 : 18,

                            padding: "20px 0px",
                          }}
                        >
                          Puis-je gagner de l’argent avec Frank ?
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          width: "90%",
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          // fontSize: 18,
                          fontSize: screen_1024 ? 18 : 14,
                        }}
                      >
                        <p>
                          Vous êtes transporteur ? En voiture, en train, en
                          trottinette, en péniche ou à pied, quel que soit le
                          mode de transport, vous gagnez de l’argent
                          !ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                          ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                          <br></br>
                          Vous envoyez un colis avec Frank ? Vous ne gagnez pas
                          d’argent, mais vous en économisez à coup sûr !
                        </p>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      elevation={0}
                      style={{
                        border: "0px",
                        background: defaultLabelColors?.main_background_new,
                      }}
                      expanded={state?.expanded_4}
                      onChange={() => handleExpanded("expanded_4")}
                    >
                      <AccordionSummary
                        style={{ border: "none", marginTop: 20 }}
                        // expandIcon={<AddIcon />}
                        expandIcon={
                          state?.expanded_4 ? (
                            <RemoveIcon
                              style={{
                                color: defaultLabelColors.main_orange_new,
                              }}
                            />
                          ) : (
                            <AddIcon />
                          )
                        } // Dynamic icon change
                        className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "500",
                            fontFamily: "montserrat-Medium",
                            // fontSize: 22,
                            fontSize: screen_1024 ? 22 : 18,

                            padding: "20px 0px",
                          }}
                        >
                          Comment fonctionne l’assurance des colis ?{" "}
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          width: "90%",
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          // fontSize: 18,
                          fontSize: screen_1024 ? 18 : 14,
                        }}
                      >
                        Tout envoi de colis via Frank est assuré à une hauteur
                        de 100 €. Pour vos colis les plus précieux, vous pouvez
                        souscrire à une assurance supplémentaire
                        (HISCOX).ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      elevation={0}
                      style={{
                        border: "0px",
                        width: "100%",
                        background: defaultLabelColors?.main_background_new,
                      }}
                      expanded={state?.expanded_5}
                      onChange={() => handleExpanded("expanded_5")}
                    >
                      <AccordionSummary
                        style={{ border: "none", marginTop: 20 }}
                        // expandIcon={<AddIcon />}
                        expandIcon={
                          state?.expanded_5 ? (
                            <RemoveIcon
                              style={{
                                color: defaultLabelColors.main_orange_new,
                              }}
                            />
                          ) : (
                            <AddIcon />
                          )
                        } // Dynamic icon change
                        className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "500",
                            fontFamily: "montserrat-Medium",
                            // fontSize: 22,
                            fontSize: screen_1024 ? 22 : 18,

                            padding: "20px 0px",
                          }}
                        >
                          Comment devenir transporteur ?
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          width: "100%",
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          // fontSize: 18,
                          fontSize: screen_1024 ? 18 : 14,
                        }}
                      >
                        <p>
                          {" "}
                          Pour devenir transporteur à nos côtés, rien de plus
                          simple :
                          ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                          ㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤㅤ
                        </p>

                        <p>
                          {" "}
                          • Vous créez un compte sur le site ou l’application de
                          Frank ;{" "}
                        </p>
                        <p>
                          {" "}
                          • Vous checkez les annonces à côté de vous, ou sur vos
                          trajets ;{" "}
                        </p>
                        <p> • Vous acceptez une offre ;</p>
                        <p>
                          {" "}
                          • Vous remettez le colis au destinataire, qui vous
                          remet un code pour valider la livraison ;{" "}
                        </p>
                        <p>
                          {" "}
                          • Vous recevez le montant de la livraison sur votre
                          porte-monnaie une fois que vous avez renseigné le
                          code.{" "}
                        </p>
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      elevation={0}
                      style={{
                        border: "0px",
                        background: defaultLabelColors?.main_background_new,
                      }}
                      expanded={state?.expanded_6}
                      onChange={() => handleExpanded("expanded_6")}
                    >
                      <AccordionSummary
                        style={{ border: "none", marginTop: 20 }}
                        // expandIcon={<AddIcon />}
                        expandIcon={
                          state?.expanded_6 ? (
                            <RemoveIcon
                              style={{
                                color: defaultLabelColors.main_orange_new,
                              }}
                            />
                          ) : (
                            <AddIcon />
                          )
                        } // Dynamic icon change
                        className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "500",
                            fontFamily: "montserrat-Medium",
                            // fontSize: 22,
                            fontSize: screen_1024 ? 22 : 18,

                            padding: "20px 0px",
                          }}
                        >
                          En tant que transporteur, comment transférer l’argent
                          de mon porte-monnaie sur mon compte bancaire ?{" "}
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          width: "90%",
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          // fontSize: 18,
                          fontSize: screen_1024 ? 18 : 14,
                        }}
                      >
                        Sur l’application Frank, il y a un espace porte-monnaie,
                        où vous trouverez le montant total de vos gains. Il
                        suffit de cliquer sur la carte bancaire, puis sur
                        “transférer sur un compte bancaire” et de renseigner les
                        informations demandées. L’argent arrive sur votre compte
                        au bout de quelques jours !
                      </AccordionDetails>
                    </Accordion>

                    <Accordion
                      elevation={0}
                      style={{
                        border: "0px",
                        background: defaultLabelColors?.main_background_new,
                      }}
                      expanded={state?.expanded_7}
                      onChange={() => handleExpanded("expanded_7")}
                    >
                      <AccordionSummary
                        style={{ border: "none", marginTop: 20 }}
                        // expandIcon={<AddIcon />}
                        expandIcon={
                          state?.expanded_7 ? (
                            <RemoveIcon
                              style={{
                                color: defaultLabelColors.main_orange_new,
                              }}
                            />
                          ) : (
                            <AddIcon />
                          )
                        } // Dynamic icon change
                        className="faq-comments"
                        sx={{
                          "&.Mui-expanded h3": {
                            color: defaultLabelColors?.main_orange_new,
                          }, // Change h3 color when expanded
                        }}
                      >
                        <h3
                          style={{
                            fontWeight: "500",
                            fontFamily: "montserrat-Medium",
                            // fontSize: 22,
                            fontSize: screen_1024 ? 22 : 18,

                            padding: "20px 0px",
                          }}
                        >
                          Y a-t-il une limite de poids pour la livraison des
                          colis ?{" "}
                        </h3>
                      </AccordionSummary>
                      <AccordionDetails
                        style={{
                          width: "90%",
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          // fontSize: 18,
                          fontSize: screen_1024 ? 18 : 14,
                        }}
                      >
                        Il n’y a pas de limite de poids chez Frank. Pour un
                        déménagement, vous pouvez prévoir le nombre de personnes
                        dont vous avez besoin en renfort en fonction de la
                        taille des meubles.
                      </AccordionDetails>
                    </Accordion>
                  </Grid>
                </Grid>
              </div>
            </div>
          </div>
        </div>
        {screen_1024 ? (
          <div
            className="main-container"
            style={{ background: defaultLabelColors?.main_background_new }}
          >
            <CustomFooter />
          </div>
        ) : screen_600 ? (
          <div
            style={{
              background: defaultLabelColors?.main_background_new,
              paddingTop: "100px",
            }}
          >
            <CustomMobileFooter />
          </div>
        ) : null}
      </div>

      <div className="mobile-screen">
        <MobileResponsive />
      </div>
    </>
  );
}
export default AboutPage;
